import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-full flex-col clear-both" }
const _hoisted_2 = { class: "px-12 flex-col lg:flex-row flex items-center lg:space-between pt-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "header flex flex-1 mb-4 lg:mb-0 text-center lg:text-left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "img/logo.svg",
    alt: "logo",
    class: "h-20 inline-flex mr-4"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "img/susmagpro.logo.svg",
    alt: "logo",
    class: "h-20 inline-flex"
  })
], -1)
const _hoisted_4 = { class: "font-space flex-col text-center text-pxblue flex justify-center mt-0 px-2 md:px-0 flex-none" }
const _hoisted_5 = { class: "text-3xl md:text-5xl font-bold mb-0" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" DiscoveREEs ")
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_10 = { class: "grid lg:grid-cols-2 gap-4" }
const _hoisted_11 = { class: "pb-8 pt-4 text-md" }
const _hoisted_12 = { class: "mb-8 font-space text-medium font-bold text-xl" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Do you want to know a secREEt? ")
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "mt-4 text-justify" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Welcome to this online Citizen Lab, an interactive platform for exploring issues and solutions, and sharing views. This platform is run by SecREEts and SUSMAGPRO, two EU funded research projects that engage European citizens to inform about and get feedback on scientific innovations that have an impact on our daily lives. You don't need to be an expert to participate, the Citizen Lab is open to everyone. ")
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "mt-4 text-justify" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" In this Citizen Lab we explore Rare Earth Elements (REEs) used in particular in the production of alloys and permanent magnets, why they have become so important for our society and economy and which challenges are connected to them. We look at how to recover these precious REEs and support their wider recycling and reuse. ")
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "mt-8" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" If you are ready to start the citizen lab, then click on the button. ")
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Let's talk Magnets ")
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "sm:pt-8 pl-8 flex-col items-center flex md:-mr-16" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "img/GIF_1.gif",
    class: "w-full magnet-girl"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _withDirectives((_openBlock(), _createElementBlock("h1", _hoisted_5, _hoisted_7)), [
          [_directive_t, 'intro.title']
        ]),
        _createElementVNode("h2", {
          class: "text-2xl md:text-3xl mt-4 font-light",
          innerHTML: _ctx.$t('intro.subtitle')
        }, null, 8, _hoisted_8)
      ]),
      _hoisted_9
    ]),
    _createVNode(_component_ScreenWrapper, {
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _withDirectives((_openBlock(), _createElementBlock("h3", _hoisted_12, _hoisted_14)), [
              [_directive_t, 'intro.title2']
            ]),
            _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_15, _hoisted_17)), [
              [_directive_t, 'intro.par1']
            ]),
            _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_18, _hoisted_20)), [
              [_directive_t, 'intro.par2']
            ]),
            _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_21, _hoisted_23)), [
              [_directive_t, 'intro.par3']
            ]),
            _withDirectives((_openBlock(), _createElementBlock("button", {
              class: "mt-8 sm:mt-16 orange-button mx-auto sm:mx-0 block",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
            }, _hoisted_25)), [
              [_directive_t, 'intro.button']
            ])
          ]),
          _hoisted_26
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ]))
}